import { extendTheme } from '@chakra-ui/react';
import { withProse } from '@nikolovlazar/chakra-ui-prose';
import {
  ColorSchemeName,
  COLOR_SCHEMES,
  PRIMARY_TEXT_COLOR,
  SURFACE_ACCENTS,
} from '@/config/themeConfig';
import { mode } from '@chakra-ui/theme-tools';
import { buttonStyles } from './components/button';
import { withProseStyles } from './withProseStyles';

export const createDynamicTheme = (colorScheme: ColorSchemeName) => {
  const globalStyles = {
    colors: {
      primary: COLOR_SCHEMES[colorScheme].primary,
      surfaceAccent: SURFACE_ACCENTS[colorScheme],
      primaryText: PRIMARY_TEXT_COLOR[colorScheme],
      blue: {
        800: '#202631',
        900: '#05091D',
      },
      gray: {
        400: '#DEDEDE',
        500: '#3E4450',
        600: '#BECBD1',
        700: '#232623',
      },
      black: {
        400: '#05091C',
        500: '#090E20',
        600: '#090D1F',
      },
      orange: {
        500: '#DE8846',
      },
    },
    styles: {
      global: (props: any) => ({
        body: {
          overflowX: 'hidden',
          bg: mode('#fdfeff', 'navy.900')(props),
          fontFamily: 'SF Pro Display',
          letterSpacing: '-0.5px',
        },
        input: {
          color: 'gray.700',
        },
        html: {
          fontFamily: 'SF Pro Display',
        },
      }),
    },
  };

  return extendTheme(globalStyles, buttonStyles, withProse(withProseStyles));
};
